import { render, staticRenderFns } from "./App.vue?vue&type=template&id=7b2b19fe"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=7b2b19fe&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports